import { linkLabel } from '@goaltree/backend/convex/lib/linkLabel'
import { Link } from '@tanstack/react-router'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { LinkChip } from '@/components/linkified-text'

export function MarkdownContent({
  text,
  isStreaming: _isStreaming,
  className,
  linkChips,
}: {
  text: string
  isStreaming?: boolean
  className?: string
  linkChips?: boolean
}) {
  return (
    <div
      className={`prose prose-sm dark:prose-invert max-w-none min-w-0 text-foreground break-words [overflow-wrap:anywhere]
        prose-p:leading-relaxed prose-p:my-1.5
        prose-headings:text-foreground prose-headings:font-semibold
        prose-strong:text-foreground
        prose-a:text-primary-text prose-a:font-medium prose-a:underline prose-a:underline-offset-2 prose-a:break-words hover:prose-a:text-primary-text/80
        prose-code:rounded prose-code:bg-muted/70 prose-code:px-1 prose-code:py-0.5 prose-code:font-mono prose-code:text-[0.8em] prose-code:text-foreground/90 prose-code:before:content-none prose-code:after:content-none
        prose-pre:rounded-lg prose-pre:border prose-pre:border-border/50 prose-pre:bg-muted/60 prose-pre:p-3 prose-pre:text-xs prose-pre:overflow-x-auto
        prose-ul:my-1.5 prose-ol:my-1.5 prose-li:my-0.5
        ${className ?? ''}`}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Open links in a new tab, and stop the click from bubbling to a
          // parent handler (e.g. a sheet row that toggles rename/open on click).
          a: ({ node: _node, href, ...props }) =>
            // In-app links (e.g. a template the coach suggests) stay in the app.
            href?.startsWith('/') ? (
              <Link to={href} {...props} onClick={(e) => e.stopPropagation()} />
            ) : linkChips && href && props.children === href && /^https?:\/\//i.test(href) ? (
              <LinkChip url={href} label={linkLabel(href)} />
            ) : (
              <a
                {...props}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              />
            ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  )
}
